import React, {Component } from 'react';
import {Grid, Row, Col} from 'react-bootstrap';

import '../GridRight.css'

import NavBar from '../../navBar/NavBar.js';

import EnergyTabs from './EnergyTabs.js';
import PhysicsMenu from '../PhysicsMenu.js';



const description = {

  padding: 10,
  border: 10,
  color: 'white',


}

class EnergyGrid extends React.Component{

  render(){

    return(

<div>

<NavBar />
<Grid fluid = {true}>
  <Row className="show-grid" >
    <Col xs={2} md={2} style = {{padding: 0}}>
        <PhysicsMenu />
    </Col>
    <Col xs={7} md={7} style = {{padding: 0}}>
       <EnergyTabs />
    </Col>
    <Col xs={3} md={3} style = {{backgroundColor: '#9E9E9E', marginTop: 47, padding: 20, paddingBottom: 160 }}>

        <div> <p style = {description}>  PRACTICE INSTRUCTIONS: <br/> <p id = "instructions"> <br/> Recall the answer to a question. <br /> Click on question to see answer. </p>  </p> </div>

    </Col>
  </Row>

</Grid>

</div>



);

}
}

export default EnergyGrid;



// WEBPACK FOOTER //
// ./src/Physics/Energy/EnergyGrid.js